import { Injectable } from '@angular/core';
import { WindowRefService } from '../window-ref.service';
import { AviaSearchParams, AviaSearchAppliedFiltersRequest } from './interfaces/avia-search';

@Injectable({ providedIn: 'root' })
export class AviaFilterStorageService {
  constructor(private windowRef: WindowRefService) {}

  createKey(params: AviaSearchParams, currency: string): string {
    return 'avia:filters:v1:' + JSON.stringify([
      params.origin.cityCode, params.origin.airportCode,
      params.destination.cityCode, params.destination.airportCode,
      params.departureDate, params.returnDate || '',
      params.passengers.adults, [...params.passengers.childAges].sort((a, b) => a - b),
      params.onlyDirectFlights, currency,
    ]);
  }

  load(key: string): AviaSearchAppliedFiltersRequest | null {
    try {
      const value = JSON.parse(this.windowRef.nativeWindow.localStorage.getItem(key));
      if (!value || !value.filters || typeof value.filters !== 'object' || Array.isArray(value.filters)) {
        return null;
      }
      return { filters: value.filters, ...(value.sortBy ? { sortBy: value.sortBy } : {}) };
    } catch {
      return null;
    }
  }

  save(key: string, request: AviaSearchAppliedFiltersRequest): void {
    try {
      const storage = this.windowRef.nativeWindow.localStorage;
      if (!Object.keys(request.filters).length && !request.sortBy) {
        storage.removeItem(key);
        return;
      }
      storage.setItem(key, JSON.stringify({
        filters: request.filters,
        ...(request.sortBy ? { sortBy: request.sortBy } : {}),
      }));
    } catch {
      // Storage may be unavailable or full; filtering must still work.
    }
  }
}
